import { render, staticRenderFns } from "./PriceTableImport.vue?vue&type=template&id=76c207e2&scoped=true"
import script from "./PriceTableImport.vue?vue&type=script&lang=js"
export * from "./PriceTableImport.vue?vue&type=script&lang=js"
import style0 from "./PriceTableImport.vue?vue&type=style&index=0&id=76c207e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c207e2",
  null
  
)

export default component.exports